import { Span } from "@clipboard-health/ui-components";

import { formatArrivalTime } from "./formatArrivalTime";

interface ArrivalTimeLabelProps {
  /**
   * The time of arrival
   */
  datetime: Date;
}

/**
 * Displays the time of arrival in predefined color and format
 * It renders a span so it should be rendered within Text component
 */
export function ArrivalTimeLabel(props: ArrivalTimeLabelProps) {
  const { datetime } = props;

  return (
    <Span
      sx={(theme) => ({
        color: theme.palette.arrivalTime?.accent,
        fontWeight: theme.typography.fontWeightMedium,
      })}
    >
      {formatArrivalTime(datetime)}
    </Span>
  );
}
